module.exports = __webpack_public_path__ + "media/bangkok/stone_sculpture-86915d38.jpg";